import "./LandingPage.scss";
import { CustomLoadingButton } from "../../components/ui/CustomButton";
import { MdCheckCircle, MdEmail, MdPhone } from "react-icons/md";
import { motion } from "framer-motion";
import { useNavigate, Navigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import newRequest from "../../utils/newRequest";
import Marquee from "react-fast-marquee";
import { IoQrCodeOutline, IoDocumentAttachSharp } from "react-icons/io5";
import { MdOutlineAutorenew } from "react-icons/md";
import { FaLinkedin, FaMoneyBill } from "react-icons/fa";
import { TbWorldWww } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";


const LandingPage = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const paymentOptions = [
    { value: 'monthly', label: 'Monthly', desc: "Start growing your intermediary with efficiency" },
    { value: 'quarterly', label: 'Quarterly', desc: "Select quarter payment plan to get 10% off" },
    { value: 'annually', label: 'Annually', desc: "Select annual payment plan and get 20% off" },
  ];

  const fetchPlans = async () => {
    try {
      const res = await newRequest.get("/sub/findAll");
      setPlans(res.data);
      // set selected default plan to monthly
      setSelectedPayment({ value: 'monthly', label: 'Monthly', desc: "Start growing your intermediary" })
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    fetchPlans();
  }, []);

  const ORG_TYPE = "insurance"; // insurance / intermediary

  //  Rendering logic comes last
  //if (ORG_TYPE === "insurance") {
  //  return <Navigate to="/login" replace />;
  //}

  return (
    <div className="landing">
      <motion.div
        className="landing-page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 1 } }}
        exit={{ opacity: 0, transition: { duration: 1 } }}
      >
        <div id="home" className="landing-wrapper">
          {/* navbar  */}
          <div className="navbar">
            {/* <h1
              style={{display:"flex", flex: "1" }}
              className='my-logo-text lg'
              onClick={() => {
                try {
                  navigate("/");
                } catch (error) {
                  console.log(error);
                }
              }}
            >
              {t('appName')}
            </h1> */}
            <span className="image-span">
              <img src="/img/landing.png" alt="" />
            </span>
            <span className="menu-wrapper" style={{ display: "flex", flex: "1" }}>
              <span className="sub-title single-menu" data-text="Home" onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}>Home</span>
              <span className="sub-title single-menu" data-text="Some Features" onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}>Some Features</span>
              <span className="sub-title single-menu" data-text="Plans & Pricing" onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}>Plans & Pricing</span>
              <span className="sub-title single-menu" data-text="Contact Us" style={{ borderRight: "none" }} onClick={() => window.open('https://iconsoft.co/contact-us/', '_blank')}>Contact Us</span>
            </span>
            <span style={{ display: "flex", flex: "1", justifyContent: "flex-end" }}>
              <CustomLoadingButton
                className="login-button"
                onClick={() => {
                  try {
                    navigate("/login");
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Login
              </CustomLoadingButton>
            </span>
          </div>
          {/* hero text */}
          <motion.div
            className="hero-text"
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
            }}
          >
            <h1>
              {t('appTagLineA')}{" "}
              <span> {t('appTagLineB')}</span>
            </h1>
            <p>
              {t('appTagLineDesc')}
            </p>
            {/* <CustomLoadingButton
              height={"45px"}
              width={"300px"}
              borderRadius={"20px"}
             data-text="Plans & Pricing" onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Signup Today!
            </CustomLoadingButton> */}
            <span className="signup-span"
              data-text="Plans & Pricing"
              onClick={() => {
                try {
                  setSelectedPlan(plans[2]);
                  const planSelected = plans[2];
                  navigate('/register', { state: planSelected });
                  // document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })
                } catch (error) {
                  console.log(error);
                }
              }}>Signup Today!</span>
          </motion.div>
          {/* application screenshort */}
          <div className="screenshort">
            <img src={currentTheme === "dark" ? "/img/wallpaper_dark.png" : "/img/wallpaper.png"} alt="" />
          </div>
        </div>

        {/* features. skewed background */}
        <div id="features" className="features">
          <span className="section-title">Some features</span>
          <div className="skewed-background">
            <div className="card-container">
              <Marquee
                autoFill={true}
                pauseOnHover={true}
                gradient={true}
                direction={"right"}
                gradientColor={"#F7F8FA"}
                gradientWidth={100}
              >
                <div className="skewed-card">
                  <div className="logo">
                    <IoDocumentAttachSharp size={50} color={"#0965c1"} />
                  </div>
                  <div className="title">
                    document attachments in all processes
                  </div>
                  <div className="desc">
                    Our innovative platform empowers insurance agents with
                    seamless document management, boosting efficiency and
                    organization.
                  </div>
                </div>
                <div className="skewed-card">
                  <div className="logo">
                    <IoQrCodeOutline size={50} color={"#db1507"} />
                  </div>
                  <div className="title">
                    QR Code on documents for enhanced validation
                  </div>
                  <div className="desc">
                    Simplify Risk Notes handling for with QR codes embedded in
                    documents, enabling quick access to vital information.
                  </div>
                </div>
                <div className="skewed-card">
                  <div className="logo">
                    <MdOutlineAutorenew size={50} color={"#FFB300"} />
                  </div>
                  <div className="title">
                    efficient renewal cycle management
                  </div>
                  <div className="desc">
                    Optimize client retention by integrating seamless renewal
                    management ensuring no lost opportunities.
                  </div>
                </div>
                <div className="skewed-card">
                  <div className="logo">
                    <FaMoneyBill size={50} color={"#1a237e"} />
                  </div>
                  <div className="title">
                    multi-currency support for all transactions
                  </div>
                  <div className="desc">
                    Optimize client retention by integrating seamless renewal
                    management ensuring no lost opportunities.
                  </div>
                </div>
              </Marquee>
            </div>
          </div>
        </div>

        {/* pricing */}
        {/* <div id="pricing" className="pricing">
          <span className="section-title">Plans & Pricing</span>
          <div className="pricing-cards-container">
            {plans?.map((row, index) => (
              <div
                key={row?._id}
                className="single-pricing-card"
              >
                {row?.sub_flag_show === "Y" && <div className="flag">{row?.sub_flag_text}</div>}
                <span className="plan-name">{row?.sub_name}</span>
                <div className="plan-price-wrapper">
                  {selectedPayment?.value === "monthly" && <span className="price">{row?.fmt_monthly_price_show}</span>}
                  {selectedPayment?.value === "quarterly" && <span className="price">{row?.fmt_quater_price_show}</span>}
                  {selectedPayment?.value === "annually" && <span className="price">{row?.fmt_annual_price_show}</span>}
                  {row?.sub_code !== "enterprise" &&
                    <div className="price-details">
                      <span className="decimals">.00</span>
                      <span className="freq">{row?.sub_monthly_price > 0 ? `${selectedPayment?.value}` : "free"} </span>
                    </div>}
                </div>
                <span style={{ fontWeight: "300", fontSize: "12px" }}>{t('taxExclusive')}</span>
                <div className="target-wrapper">
                  <span className="target">{row?.sub_target}</span>
                </div>
                <div className="features-wrapper">
                  {row?.sub_features?.map((row, index) => (
                    <span key={row?._id} className="single-feature"><MdCheckCircle className="custom-check" />{row?.feature_title}</span>
                  ))}
                </div>
                <div className="purpose-wrapper">
                  <span className="purpose">{row?.sub_purpose}</span>
                </div>
                <div className="button-wrapper">
                  <CustomLoadingButton
                    width={"80%"}
                    onClick={() => {
                      try {
                        setSelectedPlan(row);
                        const planSelected = row;
                        navigate('/register', { state: planSelected });
                      } catch (error) {
                        console.log(error)
                      }
                    }}
                  >
                    Subscribe
                  </CustomLoadingButton>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        {/* ready to transform */}
        <div className="ready-to-transform">
          <h1>
            Are you ready to transform your business?{" "}
            <span> Sign up today </span>
          </h1>
          <p>
            Join us in transforming the insurance experience and maximizing your business.
          </p>
          {/* <CustomLoadingButton
            height={"45px"}
            width={"300px"}
            borderRadius={"20px"}
            onClick={() => {
              try {
                navigate('/register', { state: null });
              } catch (error) {
                console.log(error);
              }
            }}
          >
            Start Streamlining
          </CustomLoadingButton> */}
        </div>
        <div className="footer">
          <div className="footer-wrapper">
            <div className="footer-left">
              <h1 className='my-logo-text lg'
                onClick={() => {
                  try {
                    navigate("/");
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                {t('appName')}
              </h1>
              <p>bima essentials helps you deliver the information your team need at every moment, enabling them to offer exceptional customer service</p>
              <div className="contacts-row">
                <MdEmail className="icon" /> <span className="sub-title">{"marketing@iconsoft.co"}</span>
              </div>
              <div className="contacts-row">
                <MdPhone className="icon" /> <span className="sub-title">{"+254 791 627 678"}</span>
              </div>
              <div className="contacts-row">
                <MdPhone className="icon" /> <span className="sub-title">{"+254 791 629 971"}</span>
              </div>
            </div>
            <div className="footer-right">
              <div className="footer-right-col">
                <span className="main-title">Company</span>
                <span
                  className="sub-title single-option"
                  onClick={() => window.open('https://iconsoft.co/about-us/', '_blank')}>
                  About us
                </span>
                <span
                  className="sub-title single-option"
                  onClick={() => window.open('https://iconsoft.co/jobs/', '_blank')}>
                  Careers
                </span>
                <span
                  className="sub-title single-option"
                  onClick={() => window.open('https://iconsoft.co/privacy-policy/', '_blank')} >
                  Privacy Policy
                </span>
                <span
                  className="sub-title single-option"
                  onClick={() => window.open('https://iconsoft.co/contact-us/', '_blank')}>
                  Contact us
                </span>
                <span
                  className="sub-title single-option"
                  onClick={() => window.open('https://iconsoft.co/about-us/', '_blank')}>
                  Security
                </span>
              </div>
              <div className="footer-right-col">
                <span className="main-title">Product</span>
                <span className="sub-title single-option">Underwriting</span>
                <span className="sub-title single-option">Commissions</span>
                <span className="sub-title single-option">Analytics</span>
                <span className="sub-title single-option">Reporting</span>
                <span className="sub-title single-option">Collection</span>
              </div>
              <div className="footer-right-col">
                <span className="main-title">Features</span>
                <span className="sub-title single-option">Multi-currency</span>
                <span className="sub-title single-option">Attachments</span>
                <span className="sub-title single-option">QR Codes</span>
                <span className="sub-title single-option">Renewals</span>
              </div>
              <div className="footer-right-col">
                <span className="main-title">Bima Vs</span>
                <span className="sub-title single-option">Competition</span>
              </div>
            </div>
          </div>
          <hr className="separator-h" />
          <div className="copyright-row">
            <p>© 2025 ICON Limited.</p>
            <div className="icons-row">
              <FaLinkedin className="icon" onClick={() => window.open('https://www.linkedin.com/company/icon-limited-africa/posts/?feedView=all', '_blank')} />
              {/* <FaYoutube className="icon" />
              <BsTwitterX className="icon" /> */}
              <TbWorldWww className="icon" onClick={() => window.open('https://iconsoft.co', '_blank')} />
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default LandingPage;
